module.exports = __webpack_public_path__ + "img/cleaner-image.57e08bbc.png";